// Shared by the API client and AuthContext; a module of its own because AuthContext imports the client.
export const REDIRECT_STORAGE_KEY = 'post-login-redirect';
export const SESSION_EXPIRED_KEY = 'session-expired';
